<template>
  <div :class="$style.spinePreviewContainer" v-show="show">
    <div :class="$style.bookImage">
      <div :class="$style.svgContainer"><bookImageLeft /></div>
    </div>
    <div
      ref="spinePreview"
      :class="$style.spinePreview"
      :style="{
        width: spinePreviewWidth + 'px',
        backgroundImage: spineImageUrl ? 'url(' + spineImageUrl + ')' : '',
        borderTopWidth: spinePreviewBorderWidth + 'px',
        borderBottomWidth: spinePreviewBorderWidth + 'px'
      }"
    ></div>
    <div :class="$style.bookImage">
      <div :class="$style.svgContainer"><bookImageRight /></div>
    </div>
  </div>
</template>

<script>
import bookImageLeft from "./assets/book_left.svg";
import bookImageRight from "./assets/book_right.svg";

export default {
  name: "vc-share-comic-spine-preview",
  components: {
    bookImageLeft,
    bookImageRight
  },
  data() {
    return {
      spinePreviewHeight: 0,
      show: true
    };
  },
  props: {
    spineImageUrl: {
      type: String,
      default: ""
    },
    spineImageAspectRatio: {
      type: Number,
      default: 2
    },
    layoutKey: {
      type: String,
      default: ""
    }
  },
  computed: {
    spinePreviewWidth() {
      return Math.ceil(this.spinePreviewHeight / this.spineImageAspectRatio);
    },
    spinePreviewBorderWidth() {
      return this.spinePreviewHeight / 30;
    }
  },
  watch: {
    layoutKey() {
      setTimeout(() => {
        this.resizeSpinePreview();
      }, 100);
    }
  },
  mounted() {
    window.addEventListener("resize", this.resizeSpinePreview);

    this.$nextTick(() => {
      this.resizeSpinePreview();
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeSpinePreview);
  },
  methods: {
    resizeSpinePreview() {
      if (this.$refs.spinePreview) {
        this.spinePreviewHeight = this.$refs.spinePreview.clientHeight;
        this.$nextTick(() => {
          this.spinePreviewHeight = this.$refs.spinePreview.clientHeight;
        });
      }
    }
  }
};
</script>

<style module lang="scss">
.spinePreviewContainer {
  display: flex;
  margin-top: 7%;
  font-size: 0;
}

.bookImage {
  flex-basis: 50%;

  svg {
    position: absolute;
    top: 0;
    left: 0;
  }
}

.svgContainer {
  width: 100%;
  height: 0;
  position: relative;
  padding-top: 158%;
}

.spinePreview {
  background-size: cover;
  background-position: center center;
  border-style: solid;
  border-color: #727171;
  border-width: 0;
  margin-top: 8%;
}
</style>
